export const deleteOwnerMsg =
  'Are you sure you want to detach this change impact owner?';
export const deleteGroupMsg = 'Are you sure you want to detach this group?';
export const deleteUngroupedEmployeeMsg =
  'Are you sure you want to delete this employee?';

const changeUploadParticipantMessage =
  'Are you sure you want to switch to another input method? Not saved participants will be lost.';
const changeUploadStakeholdersMessage =
  'Are you sure you want to switch to another input method? Not saved stakeholders will be lost.';
export const initiativeFormValidate = (values, isCommunication) => {
  const errors = {};

  if (!values.title) {
    errors.title = 'Title is required';
  }

  if (!values.lead) {
    errors.lead = 'Lead is required';
  }

  if (!values.start_date) {
    errors.start_date = `${isCommunication ? '' : 'Start '}Date is required`;
  }

  if (!isCommunication && !values.end_date) {
    errors.end_date = 'End Date is required';
  }

  if (values.category === null || values.category === undefined) {
    errors.category = 'Category is required';
  }

  if (!values.impact) {
    errors.impact = 'Impact is required';
  }

  if (Object.keys(errors).length === 0) {
    return {};
  }

  return errors;
};

export const onParticipantsUploadChange = (method, setUploadMethod) => {
  if (window.confirm(changeUploadParticipantMessage)) {
    setUploadMethod({ uploadParticipantsMethod: method });
  }
};

export const onStakeholdersUploadChange = (method, setUploadMethod) => {
  if (window.confirm(changeUploadStakeholdersMessage)) {
    setUploadMethod({ uploadStakeholdersMethod: method });
  }
};
